import React, { useContext, useEffect, useState } from 'react'
import { EnvironmentContext } from './EnvironmentContext'
import axios from 'axios'
import Cookies from 'js-cookie'

const useAuth = () => {
    const { isLocal } = useContext(EnvironmentContext)
    const [isFetching, setIsFetching] = useState(true)
    const [isVerified, setIsVerified] = useState(false)

    useEffect(() => {
        const token = Cookies.get('RTLSS_TOKEN')
        const refreshToken = Cookies.get(`RTLSS_REFRESH`)
        // checkPreferredStandard()
        // console.log(`pathname changed or manualcheck triggered.`, token, refreshToken)
        setIsFetching(true)
        // console.log(`protected route was rendered.`)
        // console.log(`Use Context: `, isLocal)
        axios({
            method: 'post',
            url: isLocal ? 'http://localhost:8000/check-refresh' : 'api/check-refresh',
            data: token,
            timeout: 5000,
            timeoutErrorMessage: 'Connection timed out when checking for refresh token.',
            withCredentials: true
        })
            .then((res) => {
                // console.log(`Protected route Running`, res)
                setIsVerified(true)
            })
            .catch((err) => {
                console.error(err.response)
                // setMessage(err?.response?.data?.message || "Something went wrong.")
                // setIsVerified(false)
            })
            .finally(() => {
                setIsFetching(false)
            })
    }, []) //run only once.
    return { isFetching, isVerified }
}

export default useAuth
